import React, { Component } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  FormControl,
  FormLabel,
  Textarea,
  Select,
  Text,
  VStack,
  Box
} from '@chakra-ui/react';
import colors from '../theme/colors';

class FeedbackModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      category: 'general',
      text: '',
      isSubmitting: false
    };
  }

  handleCategoryChange = (e) => {
    this.setState({ category: e.target.value });
  };

  handleTextChange = (e) => {
    this.setState({ text: e.target.value });
  };

  handleSubmit = async () => {
    const { category, text } = this.state;

    // Validation
    if (!text.trim()) {
      this.props.showToast({
        title: 'Feedback mag niet leeg zijn',
        status: 'error',
        duration: 3000
      });
      return;
    }

    if (text.trim().length < 10) {
      this.props.showToast({
        title: 'Feedback moet minimaal 10 karakters bevatten',
        status: 'error',
        duration: 3000
      });
      return;
    }

    if (text.trim().length > 2000) {
      this.props.showToast({
        title: 'Feedback mag maximaal 2000 karakters bevatten',
        status: 'error',
        duration: 3000
      });
      return;
    }

    this.setState({ isSubmitting: true });

    try {
      const API_URL = process.env.REACT_APP_API_URL || '';
      const response = await this.props.authenticatedFetch(`${API_URL}/api/feedback/submit`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          category,
          text: text.trim()
        })
      });

      const data = await response.json();

      if (data.success) {
        this.props.showToast({
          title: 'Feedback ingediend!',
          description: data.message,
          status: 'success',
          duration: 5000
        });

        // Reset form and close modal
        this.setState({
          category: 'general',
          text: '',
          isSubmitting: false
        });
        this.props.onClose();
      } else {
        this.props.showToast({
          title: 'Fout bij indienen',
          description: data.message || 'Er is iets misgegaan',
          status: 'error',
          duration: 5000
        });
        this.setState({ isSubmitting: false });
      }
    } catch (error) {
      console.error('Error submitting feedback:', error);
      this.props.showToast({
        title: 'Fout bij indienen',
        description: 'Kan geen verbinding maken met de server',
        status: 'error',
        duration: 5000
      });
      this.setState({ isSubmitting: false });
    }
  };

  render() {
    const { isOpen, onClose } = this.props;
    const { category, text, isSubmitting } = this.state;

    return (
      <Modal isOpen={isOpen} onClose={onClose} size="xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Feedback geven</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <VStack spacing={4} align="stretch">
              <Text color={colors.text.secondary}>
                Help ons Demos te verbeteren! Jouw feedback is waardevol voor de ontwikkeling van het platform.
              </Text>

              <FormControl isRequired>
                <FormLabel>Categorie</FormLabel>
                <Select
                  value={category}
                  onChange={this.handleCategoryChange}
                  placeholder="Selecteer een categorie"
                >
                  <option value="bug">Bug / Probleem</option>
                  <option value="feature_request">Nieuwe functie suggestie</option>
                  <option value="general">Algemene feedback</option>
                </Select>
              </FormControl>

              <FormControl isRequired>
                <FormLabel>Jouw feedback</FormLabel>
                <Textarea
                  value={text}
                  onChange={this.handleTextChange}
                  placeholder="Beschrijf hier je feedback in detail..."
                  rows={6}
                  resize="vertical"
                />
                <Text fontSize="sm" color={colors.text.muted} mt={1}>
                  {text.length} / 2000 karakters
                </Text>
              </FormControl>

              <Box bg={colors.primary.pale} p={3} borderRadius="md">
                <Text fontSize="sm" color={colors.primary.dark}>
                  <strong>Tip:</strong> Voor bugs, beschrijf wat je deed toen het probleem optrad en wat je verwachtte dat er zou gebeuren.
                </Text>
              </Box>
            </VStack>
          </ModalBody>

          <ModalFooter>
            <Button variant="ghost" mr={3} onClick={onClose} isDisabled={isSubmitting}>
              Annuleren
            </Button>
            <Button
              bg={colors.button.primary}
              color={colors.text.white}
              _hover={{ bg: colors.button.primaryHover }}
              _active={{ bg: colors.button.primaryActive }}
              onClick={this.handleSubmit}
              isLoading={isSubmitting}
              loadingText="Verzenden..."
            >
              Verzenden
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    );
  }
}

export default FeedbackModal;
